import Icon from '../components/Icon.vue'

Icon.register({
  'baseball-ball': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M368.5 363.9L397.3 350C408.4 372.9 423.3 393.2 441.4 410.9 475.4 368.4 495.9 314.6 495.9 256 495.9 197.5 475.5 143.8 441.7 101.4 423.9 118.7 409.1 138.5 398.1 160.9L369.4 146.8C382.2 120.8 399.4 97.8 420.2 77.8 375.6 34.7 315 8 248 8 181.1 8 120.5 34.6 75.9 77.7 96.6 97.6 113.8 120.6 126.6 146.5L97.9 160.6C86.9 138.3 72.2 118.5 54.4 101.2 20.4 143.7 0 197.4 0 256 0 314.6 20.4 368.3 54.4 410.7 72.6 393 87.6 372.7 98.7 349.7L127.5 363.6C114.6 390.3 97.2 413.9 76 434.3 120.5 477.4 181.1 504 248 504 314.8 504 375.3 477.5 419.9 434.5 398.8 414.1 381.4 390.6 368.5 363.9zM140.2 331.9L109.7 322.1C124.6 275.7 122.4 228.3 109.1 188.1L139.5 178.1C154.5 223.7 157.5 278 140.2 331.9zM356.5 178.5L386.9 188.5C373.7 228.6 371.4 276 386.3 322.5L355.8 332.3C338.5 278.3 341.5 224 356.5 178.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/baseball-ball.js
// module id = QNZs
// module chunks = 144